import { Controller } from "stimulus";
import Bouncer from 'formbouncerjs';
import conditions from './form_conditions';
import app from '../common/utils';

var bouncerJS = new Bouncer('form', {
    customValidations: {
        requiredSet: function (field) {
            // where at least one checkbox must be checked
            var wrapper = field.closest('[data-required-set]');
            if (!wrapper) return false;
            var checkboxes = wrapper.querySelectorAll('input[type="checkbox"]');
            var checkedCount = wrapper.querySelectorAll('input[type="checkbox"]:checked').length;
            var errorMessage = wrapper.querySelector(field.getAttribute('data-bouncer-target'));            
            
            // Only validate all checkboxes on last checkbox
            if (checkboxes.length > 0) {
                errorMessage.innerHTML = '';
                
                if (checkedCount === 0) {
                    for(var index = 0; index < checkboxes.length; index++) {
                        const checkbox = checkboxes[index];
                        checkbox.classList.add('error');
                        checkbox.setAttribute('aria-invalid', true);               
                        checkbox.setAttribute('aria-describedby', errorMessage.id);   
                    };
                    return true;
                }
                else {
                    for(var index = 0; index < checkboxes.length; index++) {
                        const checkbox = checkboxes[index];  
                        checkbox.classList.remove('error');
                        checkbox.removeAttribute('aria-describedby');
                        checkbox.removeAttribute('aria-invalid');              
                    };
                    return false;
                }
            }
        }
    },
    messages: {
        missingValue: {
            default: function (field) {
                return field.getAttribute('data-msg-required') ? field.getAttribute('data-msg-required') : 'This field cannot be empty.';
            }
        },
        patternMismatch : {
            default: function (field) {
                return field.getAttribute('data-msg-regex') ? field.getAttribute('data-msg-regex') : 'The value is invalid.';
            }
        },
        requiredSet: function (field) {            
            return field.getAttribute('data-required-set') ? field.getAttribute('data-required-set') : 'At least one option must be selected.';
        }
    }
});


// Prevent form submission when invalid
document.addEventListener('bouncerFormInvalid', function (event) {
    event.preventDefault();
}, false);

export default class extends Controller {

    initialize() {

        app.setup(this);

        this.settings = JSON.parse(this.element.attributes['data-settings'].value); 
        
        this.getForm().addEventListener('submit', this.refreshForm.bind(this));
        this.formSelectPlaceholders();

        conditions.init(this.getForm());
    }

    getForm() {
        return this.element.getElementsByTagName("Form")[0];
    }

    formSelectPlaceholders() {
        this.element.querySelectorAll('select').forEach(select => {
            const firstOption = select.options[0];
            if(select && select.value === '' && firstOption.value === '' && firstOption.disabled) {
                document.querySelector('select').classList.add('has-placeholder');
    
                select.addEventListener('change', (e) => {
                    e.currentTarget.classList.remove('has-placeholder');
                });
            }
        });
    }
    
    isFormValid() {

        var results = [];
        var fields = this.getForm().querySelectorAll('input,select,textarea');
        fields.forEach((field) => {
            let isValid = true;
            if(field.style.display !== 'none') {
                let result = bouncerJS.validate(field);
                if(result) isValid = result.valid;
            }
            results.push(isValid);
        });
        return results.every(r => r);
    }

    refreshForm(e) {
        e.stopPropagation();
        e.preventDefault();
        
        if(this.isFormValid()) {            
            this.element.dispatchEvent(new CustomEvent('FormSubmitted', {detail: {}, bubbles: true}));
            this.toggleLoadingState();
            var formRequestInfo = {};
            var formUrl = this.settings.formUrl;
    
            this.addRecaptchaTokenIfPresent()
                .then(() => {

                    if (!this.isFrontend()) {
                        var formData = this.getFormData();
                        formRequestInfo = { method: 'POST', body: formData };
                        formUrl = this.formAction;
                        if (!formUrl.endsWith(this.settings.formUrl)){
                            if(this.settings.formUrl.startsWith('?')) {
                                formUrl = formUrl + this.settings.formUrl;
                            }
                            else {
                                formUrl = this.settings.formUrl;
                            }
                        }
                    }
                    console.log(formUrl)
                    this.sendRequest(this.getForm(), formUrl, formRequestInfo)
                    .then(() => this.toggleLoadingState());
                });
        }
    }
    
    sendRequest(element, url, data) {
        return window.fetch(url, data)
            .then(response => response.text())
            .then((html) => this.handleResponse(element, html));
    }

    async handleResponse(element, html) {
        await this.utilites.simulateNetworkDelay(() => this.updateSectionHtml(element, html));
    }

    updateSectionHtml(element, htmlContent) {
        if(htmlContent.includes('data-form-success="true"')) {
            this.element.dispatchEvent(new CustomEvent('FormSuccess', {detail: {newContent: htmlContent, oldContent: this.getForm().innerHTML}, bubbles: true}));
            gtag('event', 'form-submission-success');
        }
        element.innerHTML = htmlContent;
        element.scrollIntoView(true);
    }

    toggleLoadingState() {
        this.element.classList.toggle(this.settings.loadingClass);
    }

    getFormData() {
        var form = this.getForm();
        this.formAction = form.getAttribute('action');
        return new FormData(form);
    }

    addRecaptchaTokenIfPresent()
    {
        var fields = this.getForm().querySelectorAll('[data-grecaptcha]');
        if(fields.length == 1) {
            var field = fields[0];
            var siteId = field.dataset.grecaptchaSiteId;
            var useCase = field.dataset.grecaptchaUseCase;

            if(grecaptcha) {
                return grecaptcha.execute(siteId, { action: useCase }).then(function (token) {
                    field.value = token;
                });
            }
        }
        return Promise.resolve([]);
    }
}